import { render, staticRenderFns } from "./LettersColumnComponent.vue?vue&type=template&id=678c34ea&"
import script from "./LettersColumnComponent.vue?vue&type=script&lang=ts&"
export * from "./LettersColumnComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('678c34ea')) {
      api.createRecord('678c34ea', component.options)
    } else {
      api.reload('678c34ea', component.options)
    }
    module.hot.accept("./LettersColumnComponent.vue?vue&type=template&id=678c34ea&", function () {
      api.rerender('678c34ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StudentDashboard/InProcessing/LettersColumnComponent.vue"
export default component.exports